/* eslint-disable react/prop-types */
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Placeholder from './Placeholder'

import * as commonActions from '../../actions/commonActions'
import * as authActions from '../../actions/authActions'
import { withRouting } from './hooks'
import { withTranslation } from 'react-i18next'

class FourOhFour extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.state = {}
  }

  UNSAFE_componentWillMount() {
    this.props.common_actions.showSideBar(false)
    this.props.common_actions.showNavBar(false)
  }

  componentWillUnmount() {
    this.props.common_actions.showSideBar(true)
    this.props.common_actions.showNavBar(true)
  }

  render() {
    const { t } = this.props
    return (
      <div
        id='404page'
        className='container d-flex align-items-center justify-content-center'
      >
        <div className='card mt-5 p-4'>
          <Placeholder
            title={t('common.fourOhFour.title')}
            icon={'fa-lock'}
            subtext1={t('common.fourOhFour.subtext1')}
            subtext2={t('common.fourOhFour.subtext2')}
            buttonText={t('common.fourOhFour.returnHome')}
            buttonIcon={'fa-home'}
            handleClick={() => this.props.navigate('/')}
          />
        </div>
      </div>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return {
    common_actions: bindActionCreators(commonActions, dispatch),
    auth_actions: bindActionCreators(authActions, dispatch),
  }
}

export default connect(
  null,
  mapDispatchToProps
)(withTranslation()(withRouting(FourOhFour)))
